import { UserProfile } from '../types';

interface PaymentData {
  plan: 'basic' | 'vip';
  amount: number;
  userProfile: UserProfile;
}

export async function initiatePayment(data: PaymentData) {
  try {
    // 记录用户数据到本地存储，作为备份
    saveToLocalStorage(data);
    
    // 尝试记录用户数据到后端
    try {
      await trackUserData(data.userProfile);
    } catch (error) {
      console.warn('User tracking failed, but continuing with payment:', error);
    }
    
    // 获取支付链接并跳转
    const paymentUrl = getPaymentUrl(data.plan, data.userProfile);
    window.location.href = paymentUrl;
  } catch (error) {
    console.error('Payment initiation failed:', error);
    throw error;
  }
}

// 获取微信支付小程序链接
function getPaymentUrl(plan: 'basic' | 'vip', profile: UserProfile): string {
  const baseUrl = 'https://aigc-dao.com/payment';
  const prices = {
    basic: 5999,
    vip: 24999
  };
  
  // 构建支付链接，包含必要参数
  const params = new URLSearchParams({
    amount: prices[plan].toString(),
    plan,
    timestamp: Date.now().toString(),
    source: 'assessment',
    industry: profile.industry.primary,
    userId: generateUserId(profile)
  });

  return `${baseUrl}?${params.toString()}`;
}

// 生成用户ID
function generateUserId(profile: UserProfile): string {
  return btoa(JSON.stringify({
    industry: profile.industry.primary,
    timestamp: Date.now()
  }));
}

// 保存到本地存储
function saveToLocalStorage(data: PaymentData) {
  try {
    const storageKey = `payment_data_${Date.now()}`;
    localStorage.setItem(storageKey, JSON.stringify({
      ...data,
      timestamp: new Date().toISOString()
    }));
  } catch (error) {
    console.warn('Failed to save to localStorage:', error);
  }
}

// 追踪用户数据
async function trackUserData(profile: UserProfile) {
  try {
    const response = await fetch('https://api.aigc-dao.com/track/user', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        profile,
        timestamp: new Date().toISOString(),
        source: 'assessment',
        version: '1.0.0'
      })
    });

    if (!response.ok) {
      throw new Error('Failed to track user data');
    }

    return await response.json();
  } catch (error) {
    console.warn('User tracking failed:', error);
    // 继续支付流程，即使追踪失败
  }
}